<template>
<!--    <div class="modal is-active" v-on:keyup.enter="saveChange"  v-on:keyup.esc="closeBtn" >-->
    <div  @keyup.enter="save">
    <div class="modal is-active" >
    <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title " v-if="dataToChild.mode=='n'" > Add New Group</p>
                <p class="modal-card-title " v-if="dataToChild.mode=='e'" >Edit {{ dataToChild.name }}</p>
            </header>
            <section class="modal-card-body">
                <!-- Content ... -->
                    <b-input name="fname"  ref="fname" v-model="dataToChild.name"   ></b-input>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-danger" @click="close">Close</b-button>
                <b-button type="is-success" @click="save">Save</b-button>
            </footer>
        </div>
    </div>
    </div>
</template>

<script>
    import {getBaseURLforBackEnd,getConfigAxios}  from '@/utils.js'
    import axios from "axios";
    import { mapState } from "vuex";

    export default {
        name: "AddEditNonAutomateGroupName",
        props:{
            dataToChild : {
                name : "",
                mode : "n" ,// n === Add New , e === Edit
                id : ""
            }
        },
        computed:{
                    ...mapState({
                       access_token: state => state.master_data.access_token,
                    })
        },
        methods:{
            save(){
                 if(this.dataToChild.name.length>3) {
                     // edit
                     if (this.dataToChild.mode === 'e') {
                         const datTo = {
                             "id": this.dataToChild.id,
                             "name": this.dataToChild.name,
                             "enable": true
                         }

                         axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                         axios.post(`${getBaseURLforBackEnd()}/api/editgrouplabnonautomate`, datTo, getConfigAxios())
                         this.$emit('closeWithEditName', this.dataToChild)
                     }
                     // add new
                     else if (this.dataToChild.mode === 'n') {
                         const datTo = {
                             "name": this.dataToChild.name
                         }
                         axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                         axios.post(`${getBaseURLforBackEnd()}/api/addnewgrouplabnonautomate`, datTo, getConfigAxios())
                         this.$emit('closeWithAddNew')
                     }
                 }else{
                     this.$buefy.dialog.alert({
                         title: 'Error',
                         message: ` Name must be more than 3 char. `,
                         type: 'is-danger',
                         hasIcon: true,
                         icon: 'times-circle',
                         iconPack: 'fa',
                         ariaRole: 'alertdialog',
                         ariaModal: true
                     })
                 }
            },
            close(){
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>

</style>